<template>
  <div class="row">
    <div class="col-12">
      <b-table ref="refUserListTable" class="articletype-relative" :items="dataUsers" :fields="tableColumns"
        primary-key="id" responsive show-empty empty-text="Không tìm thấy kết quả">
        <template #cell(full_name)="data">
          <div class="d-flex">
            <span class="pr-1">{{ data.item.full_name }}</span><small class="text-muted">{{ data.item.username
            }}</small>
          </div>
        </template>
      </b-table>
    </div>
  </div>
</template>
<script>
import {
  BCard, BRow, BCol, BButton, BLink, BOverlay, BTable
} from 'bootstrap-vue'
import { ref } from '@vue/composition-api'
import store from '@/store'
export default {
  components: {
    BCard,
    BRow,
    BCol,
    BButton,
    BLink,
    BOverlay,
    BTable
  },
  props: {
    user_ids: ''
  },
  setup(props) {
    const dataUsers = ref([])
    const tableColumns = [
      { key: 'username', sortable: false, label: 'username' },
      { key: 'alias', sortable: false, label: 'Bút danh' },
      { key: 'email', sortable: false, label: 'Email' },
      { key: 'department_name', sortable: false, label: 'Phòng ban' },
      { key: 'position_name', label: 'Chức vụ' },
      { key: 'unit_name', sortable: false, label: 'Đơn vị' },
    ];
    const featchUser = () => {

      if (props.user_ids != '') {

        store.dispatch('users/searchUser', { user_id: props.user_ids })
          .then(response => {
            let result = response.data;
            if (result.code == 200) {
              dataUsers.value = result.data ? result.data : []
            }
          })
      }
    }
    featchUser()
    return {
      dataUsers,
      tableColumns
    }
  }
}
</script>